import {
  AnalysisStateSchema,
  CONTRACTS_VERSION,
  type AnalysisState,
  type VisualizationType,
} from '@aibi/contracts';

export interface CreateAnalysisStateOptions {
  readonly id: string;
  readonly semanticModelId: string;
  readonly visualization?: VisualizationType;
}

/**
 * Crea un Analysis State vacio (sin campos) asociado a un Semantic Model.
 *
 * @example
 * const state = createAnalysisState({ id: 'a1', semanticModelId: 'model.sales' });
 * state.visualization.type; // 'table'
 */
export function createAnalysisState(options: CreateAnalysisStateOptions): AnalysisState {
  return AnalysisStateSchema.parse({
    schemaVersion: CONTRACTS_VERSION,
    id: options.id,
    semanticModelId: options.semanticModelId,
    visualization: { type: options.visualization ?? 'table' },
  });
}
